export default function TaskStatusAll({
  buckets = [
    { key:'NotStarted', label:'미착수',   count: 36 },
    { key:'InProgress', label:'진행중',   count: 82 },
    { key:'Blocked',    label:'차단',     count: 11 },
    { key:'Done',       label:'완료',     count: 140 },
  ],
  overdue = 17,
  dueSoon = 29,
}: {
  buckets?: {key:string; label:string; count:number}[];
  overdue?: number;
  dueSoon?: number;
}) {
  const total = Math.max(1, buckets.reduce((s,b)=>s+b.count,0));
  const R = 44, cx = 70, cy = 70, C = 2*Math.PI*R;
  let acc = 0;
  const colors: Record<string,string> = {
    NotStarted:'stroke-gray-300', InProgress:'stroke-blue-500',
    Blocked:'stroke-red-500', Done:'stroke-emerald-500'
  };
  return (
    <div className="rounded-2xl border bg-white p-4">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-medium">Task Status</h2>
        <div className="flex gap-2 text-xs">
          <span className="px-2 py-0.5 rounded bg-rose-100 text-rose-800">Overdue {overdue}</span>
          <span className="px-2 py-0.5 rounded bg-amber-100 text-amber-800">Due≤7d {dueSoon}</span>
        </div>
      </div>
      <div className="mt-3 grid grid-cols-2 gap-3 items-center">
        <div className="flex items-center justify-center">
          <svg width="140" height="140" viewBox="0 0 140 140">
            {/* base ring */}
            <circle cx={cx} cy={cy} r={R} className="fill-none stroke-gray-200" strokeWidth="16"/>
            {buckets.map(b=>{
              const frac = b.count/total;
              const len  = frac*C;
              const dash = `${len} ${C-len}`;
              const rot  = (acc/total)*360 - 90; // start at top
              acc += b.count;
              return (
                <g key={b.key} transform={`rotate(${rot} ${cx} ${cy})`}>
                  <circle cx={cx} cy={cy} r={R} className={`fill-none ${colors[b.key]||'stroke-gray-400'}`} strokeWidth="16" strokeDasharray={dash} strokeLinecap="butt"/>
                </g>
              );
            })}
          </svg>
        </div>
        <div className="text-xs">
          <div className="space-y-1">
            {buckets.map(b=>(
              <div key={b.key} className="flex items-center justify-between">
                <div className="inline-flex items-center gap-2">
                  <span className={`inline-block w-3 h-3 rounded ${b.key==='NotStarted'?'bg-gray-300':b.key==='InProgress'?'bg-blue-500':b.key==='Blocked'?'bg-red-500':'bg-emerald-500'}`}/>
                  <span className="text-gray-600">{b.label}</span>
                </div>
                <span className="text-gray-800 font-medium">{b.count}</span>
              </div>
            ))}
          </div>
          <div className="mt-2 text-[11px] text-gray-500">Total {total}</div>
        </div>
      </div>
    </div>
  );
}
